import { mapRouterLocaleToReal } from './locale'

/**
 * Format date
 * @param timeStamp
 * @param locale
 * @returns
 */
export const getFormattedDate = (
    timeStamp: string,
    locale = 'en',
    style?: Intl.DateTimeFormatOptions
): string => {
    try {
        locale = mapRouterLocaleToReal(locale)
        const formatDate = new Intl.DateTimeFormat(locale, style ?? {})
        return formatDate.format(new Date(timeStamp))
    } catch (e) {
        console.warn('Cannot convert the timestamp')
        return timeStamp //fallback
    }
}
